enum HTTP_CUSTOM_CODE {
  CLIENT_ERROR = 455,
  SERVER_ERROR = 555,
}

export const getErrorMessage = (error?: {
  status?: number;
  response?: { body: { message: string } };
}) => {
  switch (error?.status) {
    case 401:
      return `You don't have permission to access to DrillX. Please contact the DrillX Team at drillx@totalenergies.com, provide your IGG, name and email address.`;
    case 400:
      return 'Bad request';
    case 404:
      return 'Resource not found';
    case HTTP_CUSTOM_CODE.CLIENT_ERROR:
    case HTTP_CUSTOM_CODE.SERVER_ERROR:
      return error?.response?.body.message;
    default:
      return 'An error occured';
  }
};
